import './ModalServiceCenter.css';
import { useState } from 'react';
import { FaPhoneAlt, FaTools, FaUsers } from 'react-icons/fa';
import { ReactComponent as IconeFechar } from '../../assets/icones/close.svg';
import IconeInstagram from '../../assets/icones/instagram.svg';
import IconeLinkedin from '../../assets/icones/linkedin.svg';
import IconeSite from '../../assets/icones/og1.jpeg';

const CentralAtendimentoModal = ({ onClose }) => {
    const [exibirRedes, setExibirRedes] = useState(false);

    const contatos = {
        financeiro: {
            telefone: '558293260071',
            mensagem: `Olá, gostaria de falar com o setor Financeiro e Comercial.`,
        },
        suporte: {
            telefone: '558291623496',
            mensagem: `Olá, preciso de ajuda com o sistema de balcão web. Poderia me auxiliar?`,
        },
    };

    const redes = [
        {
            nome: 'Site Oficial',
            url: 'https://www.og1.inf.br/',
            icone: IconeSite,
            descricao: 'Acesse nosso site oficial.',
        },
        {
            nome: 'Instagram',
            url: 'https://www.instagram.com/og1oficial/',
            icone: IconeInstagram,
            descricao: 'Siga nosso Instagram',
        },
        {
            nome: 'LinkedIn',
            url: 'https://www.linkedin.com/company/og1-systems/about/',
            icone: IconeLinkedin,
            descricao: 'Conecte-se conosco',
        },
    ];

    const redirecionarWhatsApp = ({ telefone, mensagem }) => {
        const link = `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;
        window.open(link, '_blank');
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-central">
                <div className="modal-header">
                    <h2 className="modal-central-title">Central de Atendimento</h2>
                    <button className="modal-close-button" onClick={onClose}>
                        <IconeFechar
                            tabIndex={0}
                            padding="0"
                            width="20px"
                            fill="#212121"
                        />
                        <span className="modal-close-button-text">FECHAR</span>
                    </button>
                </div>

                {!exibirRedes ? (
                    <div className="card-row">
                        <div className="card" onClick={() => redirecionarWhatsApp(contatos.financeiro)}>
                            <FaPhoneAlt className="card-icon" />
                            <h3>Financeiro</h3>
                            <p>Fale com o setor financeiro e comercial.</p>
                        </div>

                        <div className="card" onClick={() => redirecionarWhatsApp(contatos.suporte)}>
                            <FaTools className="card-icon" />
                            <h3>Suporte</h3>
                            <p>Ajuda técnica para seu sistema.</p>
                        </div>

                        <div className="card" onClick={() => setExibirRedes(true)}>
                            <FaUsers className="card-icon" />
                            <h3>Redes Sociais</h3>
                            <p>Veja nossas redes e novidades.</p>
                        </div>
                    </div>
                ) : (
                    <div className="card-row">
                        {redes.map((rede, idx) => (
                            <div key={idx} className="rede-card" onClick={() => window.open(rede.url, '_blank')}>
                                <img src={rede.icone} alt={rede.nome} />
                                <h3>{rede.nome}</h3>
                                <p>{rede.descricao}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CentralAtendimentoModal;
